import React, { useState } from 'react'

import { Tab } from '@material-ui/core'
import { Wrapper, Tabs } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'
import { SalesTable } from './SalesTable'
import { PayoutTable } from './PayoutTable'

export default function LicensedKeysAnalytics({ 
  formatDate, 
  BlueRadio, 
  ResDiv, 
  Content, 
  Container,
  StartEndDatesComponent,
  setLocalityFilter,
  localities,
  localityFilter,
  selectedCompanyUuid,
  ...props }) {
  const { t } = useTranslation(['analytics'])
  const minDate = '2025-07-01'  

  function visualFormatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [day, month, year].join('.')
}
  const tabs = [ { value: 'sales' }, { value: 'payout' }, ]
  const [currentTab, setCurrentTab] = useState(tabs[0].value)
  return (
    <Container style={{padding: 0}}>
      <Tabs onChange={(e, tab) => setCurrentTab(tab)} value={currentTab}>
      {tabs.map((tab) => (
        <Tab
          disableRipple
          label={t(`analytics:licensed_keys.tabs.${tab.value}`)}
          value={tab.value}
          key={tab.value}
        />
      ))}
    </Tabs>
    {currentTab === 'sales' && (
      <SalesTable 
        Wrapper={Wrapper}
        formatDate={formatDate}
        visualFormatDate={visualFormatDate}
        StartEndDatesComponent={StartEndDatesComponent}
        setLocalityFilter={setLocalityFilter}
        localities={localities}
        localityFilter={localityFilter}
        minDate={minDate}
        selectedCompanyUuid={selectedCompanyUuid}
      />
    )}
    {currentTab === 'payout' && (
      <PayoutTable 
        Wrapper={Wrapper}
        formatDate={formatDate}
        visualFormatDate={visualFormatDate}
        StartEndDatesComponent={StartEndDatesComponent}
        minDate={minDate}
        selectedCompanyUuid={selectedCompanyUuid}
      />
    )}
    </Container>
  )
    
}
